// @ts-nocheck

import { Chart } from "chart.js/auto";
import ChartZoom from "chartjs-plugin-zoom";
import { TreemapController, TreemapElement } from "chartjs-chart-treemap";
import { event } from "jquery";
import { chart } from "highcharts";
import { xml } from "d3";
import * as XLSX from "xlsx";

export default class ChartHandler {
  constructor() {
    this.initChartButtons();
    this.sectionTitleMap = this.createSectionTitleMap();
  }

  createSectionTitleMap() {
    return {
      "A": "Land- und Forstwirtschaft, Fischerei",
      "B": "Bergbau und Gewinnung von Steinen und Erden",
      "C": "Verarbeitendes Gewerbe/Herstellung von Waren",
      "D": "Energieversorgung",
      "E": "Wasserversorgung; Abwasser- und Abfallentsorgung und Beseitigung von Umweltverschmutzungen",
      "F": "Baugewerbe/Bau",
      "G": "Handel; Instandhaltung und Reparatur von Motorfahrzeuge",
      "H": "Verkehr und Lagerei",
      "I": "Gastgewerbe/Beherbergung und Gastronomie",
      "J": "Information und Kommunikation",
      "K": "Erbringung von Finanz- und Versicherungsdienstleistungen",
      "L": "Grundstücks- und Wohnungswesen",
      "M": "Erbringung von freiberuflichen, wissenschaftlichen und technischen Dienstleistungen",
      "N": "Erbringung von sonstigen wirtschaftlichen Dienstleistungen",
      "O": "Öffentliche Verwaltung, Verteidigung; Sozialversicherung",
      "P": "Erziehung und Unterricht",
      "Q": "Gesundheits- und Sozialwesen",
      "R": "Kunst, Unterhaltung und Erholung",
      "S": "Erbringung von sonstigen Dienstleistungen",
      "T": "Private Haushalte mit Hauspersonal; Herstellung von Waren und Erbringung von Dienstleistungen durch private Haushalte für den Eigenbedarf ohne ausgeprägten Schwerpunkt",
      "U": "Exterritoriale Organisationen und Körperschaften"
    };
  }

  createCharts(dataBySection, dataByYear, selectedLocationName) {
    this.dataBySection = dataBySection;
    this.selectedLocationName = selectedLocationName;
    this.dataBySectionBarChart = dataBySection;
    this.dataByYear = dataByYear;
    this.dataByYearAggregated = null;
    this.chartBySection = null;
    this.chartByYear = null;
    this.treemapChart = null;
    this.maxYear = Math.max(...dataByYear.map((item) => Number(item.staten_year)));

    Chart.register(ChartZoom);
    Chart.register(TreemapController, TreemapElement);

    console.log(
      "Creating charts with data:",
      dataBySection,
      dataByYear,
      selectedLocationName
    );

    // cut all after [ in selectedLocationName
    selectedLocationName = selectedLocationName.split('[')[0].trim();

    document.title = "Wirtschaftsstruktur Analyse " + selectedLocationName;

    // add title to header
    const titleElement = document.getElementById("title");
    if (titleElement) {
      titleElement.innerText = "Analyse der Wirtschaftsstruktur in " + selectedLocationName;
    }

    const chartBySectionElement = document.getElementById("chartBySection");
    const chartByYearElement = document.getElementById("chartByYear");

    if (!chartBySectionElement || !chartByYearElement) {
      console.error("Could not find chart elements");
      return;
    }
    var ctxSection = document.getElementById("chartBySection").getContext("2d");
    this.chartBySection = new Chart(ctxSection, {
      type: "bar",
      data: {
        labels: this.dataBySectionBarChart.map((item) => item.section),
        datasets: [
          {
            label: "Total",
            data: this.dataBySectionBarChart.map((item) => item.totalemp),
            backgroundColor: "hsla(180 48.1% 0% / 0.5)", //rgba(54, 162, 235, 0.5) 
            borderColor: "hsla(180 48.1% 0%",
            borderWidth: 1,
          },
          {
            label: "Männer",
            data: this.dataBySectionBarChart.map((item) => item.totalemp_m),
            backgroundColor: "hsl(182 67.8% 23.1% / 0.5)", //rgba(255, 159, 64, 0.5)
            borderColor: "hsl(182 67.8% 23.1%)",
            borderWidth: 1,
            hidden: true,
          },
          {
            label: "Frauen",
            data: this.dataBySectionBarChart.map((item) => item.totalemp_w),
            backgroundColor: "hsla(360 67.8% 23.1% / 0.5)", //rgba(75, 192, 192, 0.5)
            borderColor: "hsla(360 67.8% 23.1%",
            borderWidth: 1,
            hidden: true,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        scales: {
          y: {
            beginAtZero: true,
            title: {
              display: true,
              text: "Anzahl Mitarbeitende",
            },
          },
          x: {
            title: {
              display: true,
              text: "Untersektionen",
            },
            grid: {
              display: false,
            },
          },
        },
        plugins: {
          zoom: {
            pan: {
              enabled: true,
              mode: "x",
              threshold: 10,
            },
            zoom: {
              wheel: {
                enabled: false, // Enable zooming using the mouse wheel
              },
              drag: {
                enabled: true, // Enable zooming by dragging on the canvas
              },
              pinch: {
                enabled: true, // Enable zooming by pinching (for touch devices)
              },
              mode: "x", // Allow zooming in both X and Y directions
            },
          },
          tooltip: {
            enabled: true,
            mode: "index",
            intersect: false,
            callbacks: {
              label: (context) => {
                const label = context.dataset.label;
                if (label === "Total") {
                  const item = this.dataBySectionBarChart[context.dataIndex];
                  return [
                    `Titel: ${item.titel}`,
                    `Total: ${item.totalemp}`,
                    `Männer: ${item.totalemp_m}`,
                    `Frauen: ${item.totalemp_w}`,
                    `Total VZÄ: ${parseFloat(item.totalemp_perc).toFixed(2)}`,
                    `Männer VZÄ: ${parseFloat(item.totalemp_m_perc).toFixed(
                      2
                    )}`,
                    `Frauen VZÄ: ${parseFloat(item.totalemp_w_perc).toFixed(
                      2
                    )}`,
                    `⌀ Mann: ${parseFloat(item.avgftepermanperc).toFixed(2)}%`,
                    `⌀ Frau: ${parseFloat(item.avgfteperwomanperc).toFixed(2)}%`,
                  ];
                }
                return null;
              },
            },
          },
          legend: {
            display: true,
          },
          title: {
            display: true,
            text:
              "Beschäftigte nach Untersektionen (" + this.maxYear + ")",
            font: {
              size: 14,
            },
          },
        },
      },
    });

    // Data aggregation by year for line chart
    this.aggregateYearData();

    var ctxYear = document.getElementById("chartByYear").getContext("2d");
    this.chartByYear = new Chart(ctxYear, {
      type: "line",
      data: {
        labels: this.dataByYearAggregated.map((item) => item.staten_year),
        datasets: [
          {
            label: "Total",
            data: this.dataByYearAggregated.map((item) => item.totalemp),
            backgroundColor: "hsla(180 48.1% 0% / 0.5)", //rgba(54, 162, 235, 0.5) 
            borderColor: "hsla(180 48.1% 0%",
            borderWidth: 1,
          },
          {
            label: "Männer",
            data: this.dataByYearAggregated.map((item) => item.totalemp_m),
            backgroundColor: "hsl(182 67.8% 23.1% / 0.5)", //rgba(255, 159, 64, 0.5)
            borderColor: "hsl(182 67.8% 23.1%)",
            borderWidth: 1,
          },
          {
            label: "Frauen",
            data: this.dataByYearAggregated.map((item) => item.totalemp_w),
            backgroundColor: "hsla(360 67.8% 23.1% / 0.5)", //rgba(75, 192, 192, 0.5)
            borderColor: "hsla(360 67.8% 23.1%",
            borderWidth: 1,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        scales: {
          y: {
            beginAtZero: true,
            title: {
              display: true,
              text: "Anzahl Mitarbeitende",
            },
          },
        },
        plugins: {
          tooltip: {
            enabled: true,
          },
          legend: {
            display: true,
          },
          title: {
            display: true,
            text:
              "Beschäftigte nach Jahren",
            font: {
              size: 14,
            },
          },
        },
      },
    });

    // Transform data to include subsections
    const transformedData = this.dataBySection.map((section) => ({
      group: section.abschnitte,
      subgroup: section.section,
      title: section.titel,
      sector: section.sector,
      total: parseFloat(section.totalemp),
      men: parseFloat(section.totalemp_m),
      women: parseFloat(section.totalemp_w),
      avgfteman: parseFloat(section.avgftepermanperc),
      avgftewoman: parseFloat(section.avgfteperwomanperc),
      fte: parseFloat(section.totalemp_perc),
      ftem: parseFloat(section.totalemp_m_perc),
      ftew: parseFloat(section.totalemp_w_perc),
    }));

    const baseColorMap = {};
    const baseColorBorderMap = {};
    const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ123".split("");
    letters.forEach((letter) => {
      if ("A1".includes(letter)) {
        baseColorMap[letter] = "hsla(180 48.1% 52.4% / 0.5)"; //  green for letter A - Sektor 1 hsl(161 43% 58%)
        baseColorBorderMap[letter] = "hsla(180 48.1% 52.4%)";
      } else if ("BCDEF2".includes(letter)) {
        baseColorMap[letter] = "hsla(30 100% 62.5% / 0.5)"; //  reddish spectrum for letters B to F - Sektor 2 hsl(17 96.3% 68.6%) // ${Math.random() * 20} instead of 10 
        baseColorBorderMap[letter] = "hsla(30 100% 62.5%)";
      } else if ("GHIJKLMNOPQRSTU3".includes(letter)) {
        baseColorMap[letter] = "hsla(204 81.9% 56.7% / 0.5)"; //  blueish spectrum for letters G to S - Sektor 3 hsl(222 37.3% 67.5%) // ${180 + Math.random() * 60} instead of 
        baseColorBorderMap[letter] = "hsla(204 81.9% 56.7%)";
      } else {
        baseColorMap[letter] = `hsl(0, 0%, 40%)`; //  default color for other letters
      }
    });

    const ctx = document.getElementById("treemapChart").getContext("2d");
    this.treemapChart = new Chart(ctx, {
      type: "treemap",
      data: {
        datasets: [
          {
            label: "1. Sektor Grün (A) | 2. Sektor Rot (B-F) | 3. Sektor Blau (G-U)",
            tree: transformedData,
            key: "total",
            groups: ["sector", "group", "subgroup"],
            backgroundColor: (ctx) => {
              if (!ctx || !ctx.raw) return "hsl(0, 0%, 50%)";
              const item = ctx.raw._data;
              const baseColor = baseColorMap[item.group] || baseColorMap[item.sector];
              return baseColor;
            },
            borderColor: (ctx) => {
              if (!ctx || !ctx.raw) return "hsl(0, 0%, 50%)";
              const item = ctx.raw._data;
              const baseborderColor = baseColorBorderMap[item.group] || baseColorBorderMap[item.sector];
              return baseborderColor;
            },
            borderWidth: 2,
            labels: {
              align: "center",
              display: true,
              formatter(ctx) {
                if (ctx.type !== "data") {
                  return;
                }
                const item = ctx.raw;
                let isFTE = document.getElementById("btnFTE").checked;
                let label = isFTE ? `${item.g}: ${item.vs.fte.toFixed(2)}` : `${item.g}: ${item.vs.total}`;

                const fontSize = 12;
                const padding = 1;
                let availableWidth = ctx.element.width;
                let availableHigh = ctx.element.height;
                let labelWidthEstimateFull = label.length * (fontSize * 0.6) + padding;
                let labelWidthEstimateShort = item.g.length * (fontSize * 0.6) + padding;
                let labelHeightEstimate = fontSize + padding;

                if (labelWidthEstimateFull <= availableWidth && labelHeightEstimate <= availableHigh) {
                  return label;
                }
                if (labelWidthEstimateShort <= availableWidth && labelHeightEstimate <= availableHigh) {
                  return item.g;
                }
                return "";
              },
              color: "#080808",
              font: {
                size: 12,
                weight: "normal",
              },
              hoverFont: {
                size: 12,
                weight: "bold",
              },
              position: "center",
            },
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          tooltip: {
            enabled: true,
            callbacks: {
              label: (context) => {
                const item = context.raw;
                const isSubGroup = item._data.hasOwnProperty('subgroup');
                let groupTitle = this.sectionTitleMap[item.g] || item.g;
                let isFTE = document.getElementById("btnFTE").checked;

                // Set group title for highest level
                if (item.l === 0) {
                  if (item.g === '1') {
                    groupTitle = 'Agrarwirtschaft';
                  }
                  if (item.g === '2') {
                    groupTitle = 'Industrie';
                  }
                  if (item.g === '3') {
                    groupTitle = 'Dienstleistungen';
                  }
                }

                const label = isFTE ? `${item.g}: ${item.vs.fte}` : `${item.g}: ${item.vs.total}`;
                if (isSubGroup) {
                  if (isFTE) {
                    return [
                      `Unter-sektion: ${item.g}`,
                      'Titel: ' + item._data.children[0].title,
                      `VZÄ: ${item.vs.fte.toFixed(2)}`,
                      `⌀ Mann: ${item._data.children[0].avgfteman.toFixed(2)}%`,
                      `⌀ Frau: ${item._data.children[0].avgftewoman.toFixed(2)}%`,
                    ];
                  }
                  return [
                    `Unter-sektion: ${item.g}`,
                    'Titel: ' + item._data.children[0].title,
                    `Total: ${item.vs.total}`,
                    `⌀ Mann: ${item._data.children[0].avgfteman.toFixed(2)}%`,
                    `⌀ Frau: ${item._data.children[0].avgftewoman.toFixed(2)}%`,
                  ];
                }
                if (isFTE) {
                  return [
                    `Sektion: ${item.g}`,
                    `Titel: ${groupTitle}`,
                    `VZÄ: ${item.vs.fte.toFixed(2)}`,
                  ];
                }
                return [
                  `Sektion: ${item.g}`,
                  `Titel: ${groupTitle}`,
                  `Total: ${item.vs.total}`,
                ];
              },
            },
          },
          legend: {
            display: false,
          },
          title: {
            display: true,
            text: "Beschäftigte nach Sektion und Untersektion (" + this.maxYear + ")",
            font: {
              size: 14,
            },
          },
        },
      },
    });
    const facts = this.processKeyFacts();
    this.addKeyFacts(facts);
    this.sortBySection();
  }

  updateTreeMapChart() {
    this.treemapChart.update();
    setTimeout(() => {
      this.treemapChart.update();
    }, 500);
  }

  processKeyFacts() {
    // Mitarbeiteranzahl des neusten Jahres
    const lastIndex = this.dataByYearAggregated.length - 1;
    const totalEmployees2022 = this.dataByYearAggregated[lastIndex].totalemp;
    const totalEmployees2022M = this.dataByYearAggregated[lastIndex].totalemp_m;
    const totalEmployees2022W = this.dataByYearAggregated[lastIndex].totalemp_w;
    const totalEmployees2022FTE = this.dataByYearAggregated[lastIndex].totalemp_perc.toFixed(2);
    const totalEmployees2022M_FTE = this.dataByYearAggregated[lastIndex].totalemp_m_perc.toFixed(2);
    const totalEmployees2022W_FTE = this.dataByYearAggregated[lastIndex].totalemp_w_perc.toFixed(2);

    const EmployeeFacts = "Total: " + totalEmployees2022 + " | Männer: " + totalEmployees2022M + " | Frauen: " + totalEmployees2022W;
    const EmployeeFactsFTE = "VZÄ: " + totalEmployees2022FTE + " | Männer VZÄ: " + totalEmployees2022M_FTE + " | Frauen VZÄ: " + totalEmployees2022W_FTE;

    // Top 3 sections with Most Employees
    const top3Sections = this.dataBySectionBarChart
      .sort((a, b) => b.totalemp - a.totalemp)
      .slice(0, 3)
      .map((item) => item.titel + " (Total:" + item.totalemp + ` / VZÄ: ${parseFloat(item.totalemp_perc).toFixed(2)}` + ` / ⌀: ♂ ${parseFloat(item.avgftepermanperc).toFixed(2)}% -` + ` ♀ ${parseFloat(item.avgfteperwomanperc).toFixed(2)}%)`);
    const top3SectionsFacts = top3Sections.join(" | ");

    const section1 = top3Sections[0];
    const section2 = top3Sections[1];
    const section3 = top3Sections[2];

    // employee sektor A
    const employeeSektorA = this.dataBySectionBarChart.filter((item) => item.abschnitte === 'A').reduce((acc, curr) => {
      acc.total += parseInt(curr.totalemp);
      acc.m += parseInt(curr.totalemp_m);
      acc.w += parseInt(curr.totalemp_w);
      return acc;
    }, { total: 0, m: 0, w: 0 });

    // employee sektor B - F
    const employeeSektorBtoF = this.dataBySectionBarChart.filter((item) => "BCDEF".includes(item.abschnitte)).reduce((acc, curr) => {
      acc.total += parseInt(curr.totalemp);
      acc.m += parseInt(curr.totalemp_m);
      acc.w += parseInt(curr.totalemp_w);
      return acc;
    }, { total: 0, m: 0, w: 0 });

    // employee sektor G - U
    const employeeSektorGtoU = this.dataBySectionBarChart.filter((item) => "GHIJKLMNOPQRSTU".includes(item.abschnitte)).reduce((acc, curr) => {
      acc.total += parseInt(curr.totalemp);
      acc.m += parseInt(curr.totalemp_m);
      acc.w += parseInt(curr.totalemp_w);
      return acc;
    }, { total: 0, m: 0, w: 0 });

    const employeeSektor1Percentage = (employeeSektorA.total / totalEmployees2022 * 100).toFixed(2);
    const employeeSektor2Percentage = (employeeSektorBtoF.total / totalEmployees2022 * 100).toFixed(2);
    const employeeSektor3Percentage = (employeeSektorGtoU.total / totalEmployees2022 * 100).toFixed(2);

    const employeeSektor1Facts = "Total: " + employeeSektorA.total + " | Männer: " + employeeSektorA.m + " | Frauen: " + employeeSektorA.w;
    const employeeSektor2Facts = "Total: " + employeeSektorBtoF.total + " | Männer: " + employeeSektorBtoF.m + " | Frauen: " + employeeSektorBtoF.w;
    const employeeSektor3Facts = "Total: " + employeeSektorGtoU.total + " | Männer: " + employeeSektorGtoU.m + " | Frauen: " + employeeSektorGtoU.w;

    return [
      { title: "Mitarbeitende (" + this.maxYear + ")", employeeFacts: EmployeeFacts, employeeFactsFTE: EmployeeFactsFTE },
      { title: "Top 3 Sektionen", section1: section1, section2: section2, section3: section3 },
      { title: employeeSektor1Percentage + "% " + "Agrarwirtschaft (A)", value: employeeSektor1Facts },
      { title: employeeSektor2Percentage + "% " + "Industrie (B-F)", value: employeeSektor2Facts },
      { title: employeeSektor3Percentage + "% " + "Dienstleistungen (G-U) ", value: employeeSektor3Facts },
    ];

  }

  aggregateYearData() {
    const aggregatedYearDataLineChart = this.dataByYear.reduce((acc, curr) => {
      const year = curr.staten_year;

      // Check if the year already exists in the accumulator
      if (!acc[year]) {
        // If not, initialize an entry for this year
        acc[year] = {
          staten_year: year,
          totalemp: 0,
          totalemp_m: 0,
          totalemp_w: 0,
          totalemp_perc: 0,
          totalemp_m_perc: 0,
          totalemp_w_perc: 0,
        };
      }

      // Add the current item's values to the respective year's totals
      acc[year].totalemp += parseInt(curr.totalemp);
      acc[year].totalemp_m += parseInt(curr.totalemp_m);
      acc[year].totalemp_w += parseInt(curr.totalemp_w);
      acc[year].totalemp_perc += parseFloat(curr.totalemp_perc);
      acc[year].totalemp_m_perc += parseFloat(curr.totalemp_m_perc);
      acc[year].totalemp_w_perc += parseFloat(curr.totalemp_w_perc);

      return acc;
    }, {});

    // Convert the aggregated data object to an array
    this.dataByYearAggregated = Object.values(aggregatedYearDataLineChart);
  }


  generateColors(numColors, transparency) {
    const colors = [];
    for (let i = 0; i < numColors; i++) {
      const hue = i * (360 / numColors);
      colors.push(`hsla(${hue}, 100%, 50%, ${transparency})`);
    }
    return colors;
  }

  initChartButtons() {
    const sortByTotalEmployee = document.getElementById("sortByTotalEmployee");
    const sortByTotalEmpM = document.getElementById("sortByTotalEmpM");
    const sortByTotalEmpW = document.getElementById("sortByTotalEmpW");
    const sortBySection = document.getElementById("sortBySection");
    const resetZoom = document.getElementById("resetZoom");
    const exportChartAsPNG = document.getElementById("exportChartAsPNG");
    const exportBarChartDataAsCSV = document.getElementById("exportBarChartDataAsCSV");
    const searchInput = document.getElementById("searchInput");
    const btnTotal = document.getElementById("btnTotal");
    const btnFTE = document.getElementById("btnFTE");

    if (sortByTotalEmployee) {
      sortByTotalEmployee.addEventListener("click", () => {
        this.sortByTotalEmployee();
      });
    }
    if (sortByTotalEmpM) {
      sortByTotalEmpM.addEventListener("click", () => {
        this.sortByTotalEmpM();
      });
    }
    if (sortByTotalEmpW) {
      sortByTotalEmpW.addEventListener("click", () => {
        this.sortByTotalEmpW();
      });
    }
    if (sortBySection) {
      sortBySection.addEventListener("click", () => {
        this.sortBySection();
      });
    }
    if (resetZoom) {
      resetZoom.addEventListener("click", () => {
        this.resetZoom();
      });
    }
    if (exportChartAsPNG) {
      exportChartAsPNG.addEventListener("click", () => {
        this.exportChartAsPNG();
      });
    }
    if (exportBarChartDataAsCSV) {
      exportBarChartDataAsCSV.addEventListener("click", () => {
        this.exportBarChartDataAsCSV();
      });
    }
    if (searchInput) {
      searchInput.addEventListener("input", (event) => {
        this.filterData(event.target.value);
      });
    }

    const btnGroup = document.querySelectorAll('input[name="btnradio"]');
    btnGroup.forEach((button) => {
      button.addEventListener("change", (event) => {
        if (event.target.id === "btnTotal") {
          this.handleTotalSelected();
        } else if (event.target.id === "btnFTE") {
          this.handleFTESelected();
        }
      });
    });
  }

  handleTotalSelected() {
    // chartBySection
    this.chartBySection.data.datasets[0].data = this.dataBySectionBarChart.map((item) => item.totalemp);
    this.chartBySection.data.datasets[1].data = this.dataBySectionBarChart.map((item) => item.totalemp_m);
    this.chartBySection.data.datasets[2].data = this.dataBySectionBarChart.map((item) => item.totalemp_w);
    this.chartBySection.options.scales.y.title.text = "Anzahl Mitarbeitende";
    this.chartBySection.options.plugins.title.text = "Beschäftigte nach Untersektionen (" + this.maxYear + ")";

    // chartByYear
    this.chartByYear.data.datasets[0].data = this.dataByYearAggregated.map((item) => item.totalemp);
    this.chartByYear.data.datasets[1].data = this.dataByYearAggregated.map((item) => item.totalemp_m);
    this.chartByYear.data.datasets[2].data = this.dataByYearAggregated.map((item) => item.totalemp_w);
    this.chartByYear.options.scales.y.title.text = "Anzahl Mitarbeitende";
    this.chartByYear.options.plugins.title.text = "Beschäftigte nach Jahren";

    // treeMap chart change key to total
    this.treemapChart.data.datasets[0].key = "total";
    this.treemapChart.options.plugins.title.text = "Beschäftigte nach Sektion und Untersektion (" + this.maxYear + ")";

    this.chartBySection.update();
    this.chartByYear.update();
    this.updateTreeMapChart();
  }

  handleFTESelected() {
    // chartBySection
    this.chartBySection.data.datasets[0].data = this.dataBySectionBarChart.map((item) => parseFloat(item.totalemp_perc));
    this.chartBySection.data.datasets[1].data = this.dataBySectionBarChart.map((item) => parseFloat(item.totalemp_m_perc));
    this.chartBySection.data.datasets[2].data = this.dataBySectionBarChart.map((item) => parseFloat(item.totalemp_w_perc));
    this.chartBySection.options.scales.y.title.text = "Vollzeitäquivalente";
    this.chartBySection.options.plugins.title.text = "Vollzeitäquivalente nach Untersektionen (" + this.maxYear + ")";

    // chartByYear
    this.chartByYear.data.datasets[0].data = this.dataByYearAggregated.map((item) => parseFloat(item.totalemp_perc));
    this.chartByYear.data.datasets[1].data = this.dataByYearAggregated.map((item) => parseFloat(item.totalemp_m_perc));
    this.chartByYear.data.datasets[2].data = this.dataByYearAggregated.map((item) => parseFloat(item.totalemp_w_perc));
    this.chartByYear.options.scales.y.title.text = "Vollzeitäquivalente";
    this.chartByYear.options.plugins.title.text = "Vollzeitäquivalente nach Jahren";

    // treeMap chart 
    this.treemapChart.data.datasets[0].key = "fte";
    this.treemapChart.options.plugins.title.text = "Vollzeitäquivalente nach Sektion und Untersektion (" + this.maxYear + ")";

    this.chartBySection.update();
    this.chartByYear.update();
    this.updateTreeMapChart();
  }

  sortByTotalEmployee() {

    let isFTE = document.getElementById("btnFTE").checked;

    if (!isFTE) {
      this.dataBySectionBarChart.sort((a, b) => b.totalemp - a.totalemp);
    } else {
      this.dataBySectionBarChart.sort((a, b) => b.totalemp_perc - a.totalemp_perc);
    }
    this.updateChartBySectionData();
  }

  sortByTotalEmpM() {

    let isFTE = document.getElementById("btnFTE").checked;

    if (!isFTE) {
      this.dataBySectionBarChart.sort((a, b) => b.totalemp_m - a.totalemp_m);
    } else {
      this.dataBySectionBarChart.sort((a, b) => b.totalemp_m_perc - a.totalemp_m_perc);
    }

    this.updateChartBySectionData();
  }

  sortByTotalEmpW() {

    let isFTE = document.getElementById("btnFTE").checked;

    if (!isFTE) {
      this.dataBySectionBarChart.sort((a, b) => b.totalemp_w - a.totalemp_w);
    } else {
      this.dataBySectionBarChart.sort((a, b) => b.totalemp_w_perc - a.totalemp_w_perc);
    }

    this.updateChartBySectionData();
  }

  sortBySection() {
    this.dataBySectionBarChart.sort((a, b) => a.section - b.section);
    this.updateChartBySectionData();
  }

  updateChartBySectionData() {

    let isFTE = document.getElementById("btnFTE").checked;

    // Update labels and datasets based on sorted data
    this.chartBySection.data.labels = this.dataBySectionBarChart.map((item) => item.section);

    if (!isFTE) {
      this.chartBySection.data.datasets[0].data = this.dataBySectionBarChart.map((item) => item.totalemp);
      this.chartBySection.data.datasets[1].data = this.dataBySectionBarChart.map((item) => item.totalemp_m);
      this.chartBySection.data.datasets[2].data = this.dataBySectionBarChart.map((item) => item.totalemp_w);
    } else {
      this.chartBySection.data.datasets[0].data = this.dataBySectionBarChart.map((item) => item.totalemp_perc);
      this.chartBySection.data.datasets[1].data = this.dataBySectionBarChart.map((item) => item.totalemp_m_perc);
      this.chartBySection.data.datasets[2].data = this.dataBySectionBarChart.map((item) => item.totalemp_w_perc);
    }

    this.chartBySection.update();

  }

  resetZoom() {
    this.chartBySection.resetZoom();
  }

  exportChartAsPNG() {
    if (this.chartBySection && this.chartByYear && this.treemapChart) {
      // Get the image URLs in base64 format
      var imageUrl1 = this.chartBySection.toBase64Image();
      var imageUrl2 = this.chartByYear.toBase64Image();
      var imageUrl3 = this.treemapChart.toBase64Image();

      // Create a PDF document using jsPDF
      const { jsPDF } = window.jspdf;
      const pdf = new jsPDF();

      // Add the first image to the PDF
      pdf.addImage(imageUrl1, 'PNG', 10, 10, 190, 100); // Adjust x, y, width, height as needed

      // Add the second image to the PDF (after the first one)
      pdf.addPage(); // Add a new page for the next image
      pdf.addImage(imageUrl2, 'PNG', 10, 10, 190, 100); // Adjust x, y, width, height as needed

      // Add the third image to the PDF (after the second one)
      pdf.addPage(); // Add a new page for the next image
      pdf.addImage(imageUrl3, 'PNG', 10, 10, 190, 100); // Adjust x, y, width, height as needed

      // Download the generated PDF
      pdf.save("charts.pdf");
    } else {
      alert("One or more charts are not yet ready.");
    }
  }

  filterData(searchQuery) {
    searchQuery = searchQuery.toLowerCase();

    let isFTE = document.getElementById("btnFTE").checked;

    function isNumber(value) {
      // Check if the value is a valid number
      return typeof value === "string" && !Number.isNaN(Number(value)) && value.trim() !== "";
    }

    if (isNumber(searchQuery)) {
      // Filter bar chart data by search query number (section number)
      this.dataBySectionBarChart = this.dataBySection.filter((item) => item.section.includes(searchQuery));
    } else {
      // Filter bar chart data by search query text
      this.dataBySectionBarChart = this.dataBySection.filter((item) => item.titel.toLowerCase().includes(searchQuery));
    }

    this.chartBySection.data.labels = this.dataBySectionBarChart.map((item) => item.section);

    if (!isFTE) {
      this.chartBySection.data.datasets[0].data = this.dataBySectionBarChart.map((item) => item.totalemp);
      this.chartBySection.data.datasets[1].data = this.dataBySectionBarChart.map((item) => item.totalemp_m);
      this.chartBySection.data.datasets[2].data = this.dataBySectionBarChart.map((item) => item.totalemp_w);
    } else {
      this.chartBySection.data.datasets[0].data = this.dataBySectionBarChart.map((item) => parseFloat(item.totalemp_perc));
      this.chartBySection.data.datasets[1].data = this.dataBySectionBarChart.map((item) => parseFloat(item.totalemp_m_perc));
      this.chartBySection.data.datasets[2].data = this.dataBySectionBarChart.map((item) => parseFloat(item.totalemp_w_perc));
    }
    this.chartBySection.update();

    // Filter treemap data by search query
    const transformedData = this.dataBySection.map((section) => ({
      group: section.abschnitte,
      subgroup: section.section,
      title: section.titel,
      sector: section.sector,
      total: parseFloat(section.totalemp),
      men: parseFloat(section.totalemp_m),
      women: parseFloat(section.totalemp_w),
      avgfteman: parseFloat(section.avgftepermanperc),
      avgftewoman: parseFloat(section.avgfteperwomanperc),
      fte: parseFloat(section.totalemp_perc),
      ftem: parseFloat(section.totalemp_m_perc),
      ftew: parseFloat(section.totalemp_w_perc),
    }));

    let filteredData;
    if (isNumber(searchQuery)) {
      filteredData = transformedData.filter((item) => item.subgroup.includes(searchQuery));
    } else {
      filteredData = transformedData.filter((item) => item.title.toLowerCase().includes(searchQuery)
      );
    }

    this.treemapChart.data.datasets[0].tree = filteredData;

    // Filter line chart data by search query
    let filteredDataByYear;
    if (isNumber(searchQuery)) {
      filteredDataByYear = this.dataByYear.filter((item) => item.noga082_cd.includes(searchQuery));
    } else {
      filteredDataByYear = this.dataByYear.filter((item) => item.titel.toLowerCase().includes(searchQuery));
    }

    // Aggregate filtered data by year
    const aggregatedYearDataLineChart = filteredDataByYear.reduce((acc, curr) => {
      const year = curr.staten_year;

      if (!acc[year]) {
        acc[year] = {
          staten_year: year,
          totalemp: 0,
          totalemp_m: 0,
          totalemp_w: 0,
          totalemp_perc: 0,
          totalemp_m_perc: 0,
          totalemp_w_perc: 0,
        };
      }

      acc[year].totalemp += parseInt(curr.totalemp);
      acc[year].totalemp_m += parseInt(curr.totalemp_m);
      acc[year].totalemp_w += parseInt(curr.totalemp_w);
      acc[year].totalemp_perc += parseFloat(curr.totalemp_perc);
      acc[year].totalemp_m_perc += parseFloat(curr.totalemp_m_perc);
      acc[year].totalemp_w_perc += parseFloat(curr.totalemp_w_perc);

      return acc;
    }, {});

    this.dataByYearAggregated = Object.values(aggregatedYearDataLineChart);

    // update labels and datasets based on filtered data
    this.chartByYear.data.labels = this.dataByYearAggregated.map((item) => item.staten_year);

    if (!isFTE) {
      // Update line chart
      this.chartByYear.data.datasets[0].data = this.dataByYearAggregated.map((item) => item.totalemp);
      this.chartByYear.data.datasets[1].data = this.dataByYearAggregated.map((item) => item.totalemp_m);
      this.chartByYear.data.datasets[2].data = this.dataByYearAggregated.map((item) => item.totalemp_w);
    } else {
      this.chartByYear.data.datasets[0].data = this.dataByYearAggregated.map((item) => parseFloat(item.totalemp_perc));
      this.chartByYear.data.datasets[1].data = this.dataByYearAggregated.map((item) => parseFloat(item.totalemp_m_perc));
      this.chartByYear.data.datasets[2].data = this.dataByYearAggregated.map((item) => parseFloat(item.totalemp_w_perc));
    }

    this.chartByYear.update();
    this.updateTreeMapChart();
    window.dispatchEvent(new Event('resize'));
  }

  exportBarChartDataAsCSV() {
    const selectedLocation = this.selectedLocationName.split('[')[0].trim();
    const filename = `chart_data_${selectedLocation}.xlsx`;

    const barChartData = this.dataBySectionBarChart.map((item) => ({
      Abschnitt: item.abschnitte,
      Sektion: item.section,
      Titel: item.titel.replace(/;/g, ":"),
      TotalEmp: item.totalemp,
      TotalEmp_M: item.totalemp_m,
      TotalEmp_W: item.totalemp_w,
      TotalEmp_FTE: (parseFloat(item.totalemp_perc) || 0).toFixed(2),
      TotalEmp_M_FTE: (parseFloat(item.totalemp_m_perc) || 0).toFixed(2),
      TotalEmp_W_FTE: (parseFloat(item.totalemp_w_perc) || 0).toFixed(2),
      AvgFTEPerManPerc: (parseFloat(item.avgftepermanperc) || 0).toFixed(2),
      AvgFTEPerWomanPerc: (parseFloat(item.avgfteperwomanperc) || 0).toFixed(2)
    }));

    const yearChartDataAggregated = this.dataByYearAggregated.map((item) => ({
      Jahr: item.staten_year,
      TotalEmp: item.totalemp,
      TotalEmp_M: item.totalemp_m,
      TotalEmp_W: item.totalemp_w,
      TotalEmp_FTE: (parseFloat(item.totalemp_perc) || 0).toFixed(2),
      TotalEmp_M_FTE: (parseFloat(item.totalemp_m_perc) || 0).toFixed(2),
      TotalEmp_W_FTE: (parseFloat(item.totalemp_w_perc) || 0).toFixed(2),
    }));

    const yearChartData = this.dataByYear.map((item) => ({
      Jahr: item.staten_year,
      Sektion: item.noga082_cd,
      Titel: item.titel,
      TotalEmp: item.totalemp,
      TotalEmp_M: item.totalemp_m,
      TotalEmp_W: item.totalemp_w,
      TotalEmp_FTE: (parseFloat(item.totalemp_perc) || 0).toFixed(2),
      TotalEmp_M_FTE: (parseFloat(item.totalemp_m_perc) || 0).toFixed(2),
      TotalEmp_W_FTE: (parseFloat(item.totalemp_w_perc) || 0).toFixed(2),
    }));

    // Create a new workbook
    const workbook = XLSX.utils.book_new();

    // Add Bar Chart Data to the first sheet
    const barSheet = XLSX.utils.json_to_sheet(barChartData);
    this.convertColumnsToNumbers(barSheet, ["TotalEmp", "TotalEmp_M", "TotalEmp_W", "TotalEmp_FTE", "TotalEmp_M_FTE", "TotalEmp_W_FTE", "AvgFTEPerManPerc", "AvgFTEPerWomanPerc"]);
    XLSX.utils.book_append_sheet(workbook, barSheet, "Untersektionen");

    // Add Year Chart Data Aggregated to the second sheet
    const yearSheet = XLSX.utils.json_to_sheet(yearChartDataAggregated);
    this.convertColumnsToNumbers(yearSheet, ["TotalEmp", "TotalEmp_M", "TotalEmp_W", "TotalEmp_FTE", "TotalEmp_M_FTE", "TotalEmp_W_FTE"]);
    XLSX.utils.book_append_sheet(workbook, yearSheet, "Jahresdaten");

    // Add Year Chart Data Aggregated to the third sheet
    const yearSheet2 = XLSX.utils.json_to_sheet(yearChartData);
    this.convertColumnsToNumbers(yearSheet2, ["TotalEmp", "TotalEmp_M", "TotalEmp_W", "TotalEmp_FTE", "TotalEmp_M_FTE", "TotalEmp_W_FTE"]);
    XLSX.utils.book_append_sheet(workbook, yearSheet2, "Jahresdaten (Detail)");

    // Add the key facts to the fourth sheet
    const keyFactsSheet = XLSX.utils.json_to_sheet(this.processKeyFacts());
    XLSX.utils.book_append_sheet(workbook, keyFactsSheet, "Key Facts");

    // Export the workbook to an Excel file
    XLSX.writeFile(workbook, filename);
  }


  // Helper function to set numeric columns
  convertColumnsToNumbers(sheet, columns) {
    const range = XLSX.utils.decode_range(sheet["!ref"]);
    for (let colName of columns) {
      for (let row = range.s.r + 1; row <= range.e.r; row++) { // Skip the header row
        const cellAddress = XLSX.utils.encode_cell({ c: this.findColumnIndex(sheet, colName), r: row });
        const cell = sheet[cellAddress];
        if (cell && !isNaN(cell.v)) {
          cell.v = parseFloat(cell.v); // Set the value as a number
          cell.t = "n"; // Set the type as number
        }
      }
    }
  }

  // Helper function to find the column index of a header
  findColumnIndex(sheet, headerName) {
    const range = XLSX.utils.decode_range(sheet["!ref"]);
    for (let col = range.s.c; col <= range.e.c; col++) {
      const cellAddress = XLSX.utils.encode_cell({ c: col, r: range.s.r });
      const cell = sheet[cellAddress];
      if (cell && cell.v === headerName) {
        return col;
      }
    }
    return -1; // Column not found
  }

  addKeyFacts(facts) {
    const keyFactsList = document.getElementById("keyFactsList");
    if (!keyFactsList) {
      console.error("Could not find key facts list element");
      return;
    }

    keyFactsList.innerHTML = "";

    facts.forEach((fact) => {
      // create items for each fact category
      if (fact.title === "Top 3 Sektionen") {
        const listItem = document.createElement("li");
        const listItemDetails = document.createElement("ul");
        listItem.className = "list-group-item";
        listItem.innerHTML = `<strong>${fact.title}:</strong>`;
        listItemDetails.innerHTML = `<li>${fact.section1}</li><li>${fact.section2}</li><li>${fact.section3}</li>`;
        keyFactsList.appendChild(listItem);
        listItem.appendChild(listItemDetails);
      } else if (fact.title === "Mitarbeitende (" + this.maxYear + ")") {
        const listItem = document.createElement("li");
        const listItemDetails = document.createElement("ul");
        listItem.className = "list-group-item";
        listItem.innerHTML = `<strong>${fact.title}:</strong>`;
        listItemDetails.innerHTML = `<li>${fact.employeeFacts}</li><li>${fact.employeeFactsFTE}</li>`;
        keyFactsList.appendChild(listItem);
        listItem.appendChild(listItemDetails);
      } else {
        const listItem = document.createElement("li");
        listItem.className = "list-group-item";
        listItem.innerHTML = `<strong>${fact.title}:</strong> ${fact.value}`;
        keyFactsList.appendChild(listItem);
      }
    });
  }
}

const dataBySection = JSON.parse(window.localStorage.getItem("dataBySection"));
const dataByYear = JSON.parse(window.localStorage.getItem("dataByYear"));
const selectedLocationName = window.localStorage.getItem("selectedLocationName");

if (dataBySection && dataByYear && selectedLocationName) {
  const chartHandler = new ChartHandler();
  chartHandler.createCharts(dataBySection, dataByYear, selectedLocationName);
  setTimeout(() => {
    chartHandler.treemapChart.update();
  }, 500);
  let maxYear = Math.max(...dataByYear.map((item) => Number(item.staten_year)));
  document.getElementById("disclaimer").innerText = `Datenquelle: Bundesamt für Statistik, Statistik der Unternehmensstruktur STATENT, 2011-${maxYear}`;
}

window.onbeforeunload = function () {
  window.localStorage.removeItem("dataBySection");
  window.localStorage.removeItem("dataByYear");
  window.localStorage.removeItem("selectedLocationName");
};
